// extracted by mini-css-extract-plugin
export default {"widget":"widget-module--widget--v6gMM","image":"widget-module--image--Pyfol","title":"widget-module--title--WCC6p","arrow":"widget-module--arrow--luARo"};